import { isHiddenFieldType } from "../constants/fieldTypes";

/**
 * Build the form's own copy of one of the store's custom fields, as switching
 * that field on in the form builder stores it.
 *
 * The two differ in what `field` — the key the value is submitted under —
 * means. A visible field keys itself off its label, so renaming it renames the
 * key. A hidden field's key is the query parameter it reads from the signup
 * link: the marketing site owns that name and it has no reason to match the
 * label staff read in the dashboard, so it is carried over as-is.
 *
 * @param {Object} storeField - A custom field from selectedStore.custom_fields.
 * @param {Object} [originalState] - The field's state from before it was last
 *   switched off, so toggling it back on restores whether it was required.
 * @returns {Object} The field entry for form.content.fields.
 */
export function formFieldFromStoreField(storeField, originalState) {
  return {
    type: storeField.field_type,
    label: storeField.label,
    field: isHiddenFieldType(storeField.field_type)
      ? storeField.field
      : storeField.label,
    options: storeField.options || [],
    required: originalState?.wasEnabled ? originalState.wasRequired : false,
    unique: false,
  };
}
